import { AvailableStateRegistry } from '../registries/AvailableStateRegistry';
import { Policy } from '../customer/Policy';
import { UICategory, UILoggerSingleton } from '../logger/UILoggerSingleton';

export class MetadataHierarchy {
  static build(product, state: string): string[] {
    // Find product group and channel group from the incoming params
    const productGroup = product.type.group.name;
    const channel = product.channel;
    const channelGroup = channel.group.name;

    const stateOptions = AvailableStateRegistry[channel.code][state];
    if (!stateOptions) {
      UILoggerSingleton.getInstance().error(
        {
          module: 'MetadataHierarchy',
          function: 'build',
          category: UICategory.request,
          error: {
            isHumanRelated: false,
          },
        },
        `Invalid channel code and state combo ${channel.code}, ${state}
                            not found in registry for hierarchy`
      );
    }

    const iccOption = !stateOptions || stateOptions.isICC ? 'ICC' : 'NonICC';
    return [channelGroup, productGroup, iccOption, channel.code, state];
  }

  static getOptions(hierarchy: string[]) {
    // Hierarchy needs to have at least 4 levels  -
    // 1. productGroup (HIT or MM..)
    // 2. channelGroup (Term, DI...)
    // 3. state group (icc, non icc)
    // 4. channel (haven, cas..)
    // 5. state (owner state)
    const options: any = {};
    const len: number = hierarchy.length;

    if (!(hierarchy instanceof Array) || len < 4) {
      return options;
    }

    options.productGroup = hierarchy[0];
    options.channelGroup = hierarchy[1];
    options.stateGroup = hierarchy[2];
    options.channel = hierarchy[3];
    options.state = len > 4 ? hierarchy[4] : '';

    return options;
  }

  static getChannelConfigurations(channel: string) {
    if (channel && AvailableStateRegistry[channel]) {
      return AvailableStateRegistry[channel];
    }
  }

  static getStateConfigurations(channel: string, state: string) {
    const channelConfigs = MetadataHierarchy.getChannelConfigurations(channel);
    if (state && channelConfigs[state]) {
      return channelConfigs[state];
    }
  }

  static getConfigurationsForHierarchy(hierarchy: string[]) {
    const options = MetadataHierarchy.getOptions(hierarchy);
    return MetadataHierarchy.getConfigurations(options);
  }

  static getConfigurations(options) {
    const channelConfigs = MetadataHierarchy.getStateConfigurations(options.channel, options.state);
    if (channelConfigs) {
      return channelConfigs;
    }
  }

  static getConfiguration(options, configurationProperty: string) {
    const configurations = MetadataHierarchy.getConfigurations(options);

    if (configurations) {
      return configurations[configurationProperty];
    }
  }

  static getConfigurationByChannelAndState(channel, state, configurationProperty) {
    const options = {
      channel: channel,
      state: state,
    };

    return MetadataHierarchy.getConfiguration(options, configurationProperty);
  }

  static getConfigurationsForPolicy(policy: Policy) {
    if (policy) {
      return MetadataHierarchy.getConfigurationsForHierarchy(policy.getHierarchy());
    }
  }
}
